<template>
  <div class="box3-pad p-2">
    <!-- {{ status_overload }} -->
    <!-- {{ control_pump }} -->
    <!-- {{ task_value }} -->
    <!-- {{ pump_station }} {{ pump_id }} -->
    <vs-row class="mt-2" style="align-items: center">
      <h4 class="text_box2_3_1" @click="isOpenTitle = true">{{ header }}</h4>

      <vs-popup class="pump-title-description" :title="header" :active.sync="isOpenTitle">
        <p class="pump-title-description-title">Description</p>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Station</div>
          <div class="pump-title-description-value">{{ pump_station }}</div>
        </div>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">ID</div>
          <div class="pump-title-description-value">{{ pump_id }}</div>
        </div>

        <p class="pump-title-description-title">Controller</p>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Control from</div>
          <div class="pump-title-description-value">{{ control_status }}</div>
        </div>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Power Mode</div>
          <div class="pump-title-description-value">{{ mode_pw ? mode_pw.replaceAll('_', ' ') : 'N/a' }}</div>
        </div>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Overload Status</div>
          <div class="pump-title-description-value">
            <span :class="`${status_overload ? 'text-danger' : 'text-success'}`">{{ status_overload ? 'Yes' :
                'No'
            }}</span>
          </div>
        </div>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Power Status</div>
          <div class="pump-title-description-value">
            <span :class="`${status ? 'text-success' : 'text-danger'}`">{{ status ? 'ON' : 'OFF' }}</span>
          </div>
        </div>

        <p class="pump-title-description-title">Technical</p>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Power Consumption</div>
          <div class="pump-title-description-value">{{ kwh_status }} kWh</div>
        </div>
        <div class="pump-title-description-scope">
          <div class="pump-title-description-label">Daily Runtime</div>
          <!-- <div class="pump-title-description-value">{{ runtime }} m<sup>3</sup>/h</div> -->
          <div class="pump-title-description-value">{{ runtimeWithCommas }} m<sup>3</sup>/h</div>
        </div>

        <!-- <p class="pump-title-description-title">Programming</p>
        <div class="pump-title-description-scope">
          {{ JSON.stringify($props) }}
        </div> -->
      </vs-popup>

      <vs-spacer />

      <vs-button size="small" color="primary" v-if="['Web'].includes(control_status)" style="border-radius: 30px"
        type="filled" @click="popupActivo2 = true">{{ control_pump }}</vs-button>

      <!-- <vs-icon
        icon="date_range"
     
        size="25px"
        color="#707070"
      ></vs-icon
      >{{ task_value.select }} -->
    </vs-row>
    <div v-if="status_overload">
      <div class="img-row-box3">
        <img style="width: 80%; border-radius: 0 0 30px 30px" src="@/assets/images/NikhomLatKrabang/overload.gif"
          alt="" />

        <img class="img-row-box3-button-fix" style="width: 10%"
          src="@/assets/images/NikhomLatKrabang/settting_icon_danger.png" alt="" />
      </div>
    </div>
    <div v-else>
      <!-- {{ control_status }} -->
      <!-- {{ mode_pw }} -->
      <!-- {{ status }} -->

      <div v-if="['Web'].includes(control_status)">
        <div v-if="status" class="img-row-box3">
          <img style="width: 80%; border-radius: 0 0 30px 30px" src="@/assets/images/NikhomLatKrabang/valveOn.gif"
            alt="Valve ON" />
          <img v-if="['Web_Manual'].includes(mode_pw)" @click="save_status(!status)" class="img-row-box3-button"
            style="width: 20%" src="@/assets/images/NikhomLatKrabang/off.png" alt="Turn Off Button" />
        </div>
        <div v-else class="img-row-box3">
          <img style="width: 80%; border-radius: 0 0 30px 30px" src="@/assets/images/NikhomLatKrabang/valveOff.gif"
            alt="Valve OFF" />
          <img v-if="['Web_Manual'].includes(mode_pw)" @click="save_status(!status)" class="img-row-box3-button"
            style="width: 20%" src="@/assets/images/NikhomLatKrabang/on.png" alt="Turn On Button" />
        </div>
      </div>
      <div v-if="['Station'].includes(control_status)">
        <div v-if="status" class="img-row-box3 disabledDiv">
          <img style="width: 80%; border-radius: 0 0 30px 30px" src="@/assets/images/NikhomLatKrabang/valveOn.gif"
            alt="" />
        </div>
        <div v-else class="img-row-box3">
          <img style="width: 80%; border-radius: 0 0 30px 30px" src="@/assets/images/NikhomLatKrabang/valveOff.gif"
            alt="" />
        </div>
      </div>
    </div>
    <!-- <div align="center">
      <h4 style="font-weight: 600; color: #707070">{{ kwh_status }} kWh</h4>
    </div> -->

    <ul class="text-box3-right ml-2">
      <li>Power Consumption : {{ kwh_status }} kWh</li>
      <li>Daily Runtime: {{ runtimeWithCommas }} m<sup>3</sup>/h</li>
    </ul>

    <vs-popup classContent="popup-example" :title="header + ' Settings'" :active.sync="popupActivo2">
      <!-- <pre>{{ task_value }}</pre> -->
      <vs-select class="selectExample" label="Figuras" v-model="control_pump">
        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options4" />
      </vs-select>

      <div v-if="control_pump == 'Web_schedule'" class="main-con mt-4">
        <div style="display: flex">
          <div style="padding-left: 5px" class="mr-3">Schedule</div>

          <div style="width: 100%">
            <vs-radio v-model="task_value.type" vs-name="radios1" style="justify-content: flex-start" vs-value="day">Day
            </vs-radio>
            <div v-if="task_value.type === 'day'" class="container-ma mt-3 mb-3">
              <div class="g1">
                <vs-select style="width: 100%" label="Select date" v-model="task_value.day">
                  <vs-select-item :key="index" :value="item.value" :text="item.day" v-for="(item, index) in dataWeek" />
                </vs-select>
              </div>
              <div class="g2">
                <label for="timepicker-starttime" style="
                    padding-left: 5px;
                    display: inline-block;
                    margin-bottom: 0.5rem;
                  ">Select start time</label>
                <b-form-timepicker v-model="task_value.starttime" id="timepicker-starttime" placeholder="Choose a time"
                  locale="en"></b-form-timepicker>
              </div>
              <div class="g3">
                <label for="timepicker-endtime">Select end time</label>
                <b-form-timepicker v-model="task_value.endtime" id="timepicker-endtime" placeholder="Choose a time"
                  locale="en"></b-form-timepicker>
              </div>
            </div>
            <vs-radio v-model="task_value.type" vs-name="radios1" style="justify-content: flex-start" vs-value="week">
              Week</vs-radio>
            <div v-if="task_value.type === 'week'" class="container-ma mt-3 mb-3">
              <div class="g1">
                <vs-select style="width: 100%" label="Select date" v-model="task_value.day">
                  <vs-select-item :key="index" :value="item.value" :text="item.day" v-for="(item, index) in dataWeek" />
                </vs-select>
              </div>
              <div class="g2">
                <label for="timepicker-starttime" style="
                    padding-left: 5px;
                    display: inline-block;
                    margin-bottom: 0.5rem;
                  ">Select start time</label>
                <b-form-timepicker v-model="task_value.starttime" id="timepicker-starttime" placeholder="Choose a time"
                  locale="en"></b-form-timepicker>
              </div>
              <div class="g3">
                <label for="timepicker-endtime">Select end time</label>
                <b-form-timepicker v-model="task_value.endtime" id="timepicker-endtime" placeholder="Choose a time"
                  locale="en"></b-form-timepicker>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: flex-end">
        <vs-button @click="cancel_pop" color="dark" class="btn-modal" type="flat">Cancel</vs-button>
        <vs-button color="success" @click="submit_data()" class="btn-modal" type="filled">Save</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: [
    "header",
    "status",
    "kwh_status",
    "control_status",
    "mode_pw",
    "pump_id",
    "pump_station",
    "status_overload",
    "runtime",
  ],
  data() {
    return {
      task_value: {
        select: null,
        type: null,
        name: null,
        day: null,
        starttime: null,
        endtime: null,
      },
      control_pump: null,
      options4: [
        { text: "Web Auto", value: "Web_Auto" },
        { text: "Web Manual", value: "Web_Manual" },
        { text: "Web Schedule", value: "Web_schedule" },
      ],
      popupActivo2: false,
      dataWeek: [
        { day: "Monday", value: 1 },
        { day: "Tuesday", value: 2 },
        { day: "Wednesday", value: 3 },
        { day: "Thursday", value: 4 },
        { day: "Friday", value: 5 },
        { day: "Saturday", value: 6 },
        { day: "Sunday", value: 7 },
      ],
      // mode_control: ""
      isOpenTitle: false
    };
  },
  methods: {
    save_status(item) {
      console.log('save_status.start', item);
      let name_param = {};
      let value_status;
      if (item == true) {
        value_status = "Start";
      } else {
        value_status = "Stop";
      }

      name_param["Status_Run_M" + this.pump_id] = item;
      console.log('save_status.params', name_param);

      let body = {
        command: {
          Type: "Command",
          Station: this.pump_station,
          Pump: this.pump_id,
          Mode_C: "Web_Manual",
          Status: value_status,
        },
      };

      console.log('save_status.body', body);

      this.$API
        .post(`lkb/command`, body)
        .then((result) => {
          console.log('save_status.lkb/command -> result', result);

          this.$vs.notify({
            title: "Success",
            text:
              value_status +
              " " +
              this.header +
              " ( Station " +
              this.pump_station +
              " )",
            color: "success",
            position: "top-center",
            time: 6000,
            icon: "power_settings_new",
          });
        })
        .catch((error) => {
          console.log('Save Status Command -> Error', error);
          this.$vs.notify({
            title: "Error",
            text: "Please try again later.",
            icon: "warning",
            color: "danger",
          });
        });
    },
    cancel_pop() {
      this.popupActivo2 = false;
      this.control_pump = this.mode_pw;
    },
    submit_data_setting() {
      console.log('submit_data_setting', this.control_pump);
      let setting_sch = {};
      if (this.control_pump == "Web_schedule") {
        setting_sch = this.task_value;
      } else {
        setting_sch = {};
      }
      let body_setting = {
        station: "lkb_station" + this.pump_station,
        pump: this.pump_id,
        setting_pump: setting_sch,
      };
      console.log(body_setting);
      console.log('lkb/setting', body_setting);
      this.$API
        .post(`lkb/setting`, body_setting)
        .then((result) => {
          console.log('lkb/setting -> response', result);
          this.task_value = setting_sch;
          this.popupActivo2 = false;
          this.$vs.notify({
            title: "Success",
            text:
              this.control_pump +
              " " +
              this.header +
              " ( Station " +
              this.pump_station +
              " )",
            color: "success",
            position: "top-center",
            time: 6000,
            icon: "power_settings_new",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: "Please try again later.",
            icon: "warning",
            color: "danger",
          });
        });
    },
    submit_data() {
      let body_command = {
        command: {
          Type: "Setting_Mode",
          Station: this.pump_station,
          Pump: this.pump_id,
          Mode: this.control_pump,
        },
      };
      // console.log(body_command);
      this.$API
        .post(`lkb/command`, body_command)
        .then((result) => {
          // console.log(result);

          this.submit_data_setting();
          this.popupActivo2 = false;
          this.$vs.notify({
            title: "Success",
            text:
              this.control_pump +
              " " +
              this.header +
              " ( Station " +
              this.pump_station +
              " )",
            color: "success",
            position: "top-center",
            time: 6000,
            icon: "power_settings_new",
          });
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: "Please try again later.",
            icon: "warning",
            color: "danger",
          });
        });
    },
  },
  mounted() {
    // this.task_value = this.setting_pump;
    console.log(this.header, this.pump_id, this.pump_station, this.control_status, this.kwh_status, this.runtime, this.mode_pw, this.status_overload, this.status,)
    this.control_pump = this.mode_pw;
    this.$API
      .get(`lkb/setting/${this.pump_station}/${this.pump_id}`)
      .then((result) => {
        console.log(result.data);
        this.task_value = result.data;
      });
  },
  computed: {
    runtimeWithCommas() {
      return this.runtime.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
};
</script>

<style scoped>
.pump-title-description {}

.pump-title-description .pump-title-description-scope {
  padding-left: 1rem;
  display: flex;
  font-size: 1.1rem;
  line-height: 1.1rem;
  margin-bottom: 0.8rem;
  word-break: break-all;
}

.pump-title-description .pump-title-description-scope:last-child {
  margin-bottom: 0;
}

.pump-title-description .pump-title-description-title {
  color: #707070;
  font-size: 0.9rem;
  line-height: 0.9rem;
  margin: 1.25rem 0 1rem;
}

.pump-title-description .pump-title-description-title:first-child {
  margin-top: 0;
}

.pump-title-description .pump-title-description-scope .pump-title-description-label {
  flex: 1;
  font-weight: 300;
}

.pump-title-description .pump-title-description-scope .pump-title-description-value {
  flex: 1;
  text-align: right;
  font-weight: 500;
}

.container-ma {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 10px 10px;
  grid-template-areas:
    "g1 g1 . ."
    "g2 g2 g3 g3";
}

.g1 {
  grid-area: g1;
}

.g2 {
  grid-area: g2;
}

.g3 {
  grid-area: g3;
}

.btn-modal {
  width: 80px;
  border-radius: 30px;
}

.div_row3 {
  display: flex;
  align-items: flex-start;
}

.box3-pad {
  padding: 10px;
}

.img-row-box3 {
  display: flex;
  position: relative;
  justify-content: space-around;
  align-items: center;
}

.img-row-box3-button-fix {
  top: 50%;
  position: absolute;
  cursor: pointer;
}

.img-row-box3-button {
  top: 70%;
  position: absolute;
  cursor: pointer;
}

.img-row-box3-button:hover {
  /* bottom: 0; */
  transition: all 0.5s ease;
}

.al-box3 {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.text_box2_3_1 {
  cursor: pointer;
  margin-left: 10px;
  font-size: 1rem;
  /* width: 100%; */
  font-weight: 600;
  color: #707070;
}

.text-box3-right {
  /* display: flex;
  justify-content: flex-end;
  margin-right: 5%;
  padding: 5px; */
  color: #707070;
  font-weight: 300;
  list-style: none;
}

.disabledDiv {
  pointer-events: none;
  /* opacity: 0.4; */
}

@media only screen and (max-width: 700px) {}
</style>